import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, LinearProgress, Button } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { deleteAccount } from "api/user";
import { signOut } from "features/auth/reducer";
import i18n from "./i18n";

// prop types
interface DeleteAccountDialogProps {
    show: boolean,
    onClose: () => void,
}

// delete club dialog
const DeleteAccountDialog = ({ show, onClose }: DeleteAccountDialogProps) => {
    const dispatch = useDispatch();

    // snackbar
    const { enqueueSnackbar } = useSnackbar();
    const displayError = (error: any) => enqueueSnackbar(
        `${i18n.anErrorOccurred}: ${error.description} (${error.type})`,
        { variant: "error" },
    );

    // ui state
    const [isLoading, setLoading] = useState(false);

    // execute action
    const execute = async () => {
        setLoading(true);
        try {
            await deleteAccount();
            dispatch(signOut());
            enqueueSnackbar(i18n.deleteAccountSuccess, { variant: "success" });
            onClose();
        } catch (error) {
            displayError(error);
        }
        setLoading(false);
    };

    // render
    return (
        <Dialog open={show} onClose={onClose}>
            <DialogTitle>{i18n.deleteAccount}</DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                    {i18n.deleteAccountDesc}
                </DialogContentText>
            </DialogContent>
            {isLoading && <LinearProgress />}
            <DialogActions>
                <Button color="secondary" onClick={onClose}>
                    {i18n.cancel}
                </Button>
                <Button style={{ color: "#d44336" }} disabled={isLoading} onClick={execute}>
                    {i18n.deleteIrrevocably}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteAccountDialog;
